import { Variables } from "@clerk/types";
import { Theme } from "@mui/material";

export function getClerkVariables(muiTheme: Theme): Variables {
  return {
    colorPrimary: muiTheme.palette.primary.main,
    colorBackground: muiTheme.palette.background.default,
    colorText: muiTheme.palette.text.primary,
    colorTextSecondary: muiTheme.palette.text.secondary,
    borderRadius: "2px",
  };
}
